module.exports = __webpack_public_path__ + "media/images/lb/433-feff13cfdfa75e827f0c7338b088ab9d.svg";